package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPremium_support_and_nodesPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/premium_support_and_nodes.md", FrontMatterElement.EmptyMap))
}

@Page("/faqs_and_info/premium-support-and-nodes")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Premium_support_and_nodesPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("premium-support-nodes") }) {
        org.jetbrains.compose.web.dom.Text("Premium Support & Nodes")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("If you buy a pack worth ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("${'$'}3 or more")
            }
            org.jetbrains.compose.web.dom.Text(" using one of the methods listed in the")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.silk.components.navigation.Link("/faqs_and_info/payment-guide") {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("Payment Guide")
            }
        }
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text(", you get access to Premium Nodes and Premium Support. This payment is ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("not")
            }
            org.jetbrains.compose.web.dom.Text(" monthly or yearly. Buying one qualifying pack is enough to keep premium node access and support permanently.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("https://68f1468085da5707d2cf1261.featurebase-attachments.com/c/article/68f15649a47c1960a4d0e131/0199eebb-6292-7728-8ad6-8e8289ce1881/b64u-MDE5OWVlYmItNjI1OS03MjU5LThiZjgtMGNhMmMyNjg3NDJh.jpeg?X-Amz-Expires=3600&X-Amz-Date=20260406T220000Z&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=DO801TYC4FCVNNEKURKM%2F20260406%2Ffra1%2Fs3%2Faws4_request&X-Amz-SignedHeaders=host&X-Amz-Signature=c061edec8d622e774c1c89e63e2053c7983406fb20eec7b2ab675eeaa8f63a04", "")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("what-does-premium-support-mean") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("What does Premium Support mean?")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#premium-nodes");attr("id", "premium-nodes")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Your tickets will be answered faster by the Support Team or Developers.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Please note:")
        }
        org.jetbrains.compose.web.dom.Text(" this ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("does not")
        }
        org.jetbrains.compose.web.dom.Text(" mean you will get an instant solution or a reply to every ticket. We still have a queue, and Support Team members cannot handle ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("server-side requests")
        }
        org.jetbrains.compose.web.dom.Text(". In those cases, you ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("need to wait for a developer")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("what-does-premium-node-access-mean") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("What does Premium Node Access mean?")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#premium-nodes");attr("id", "premium-nodes")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Your ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("new")
            }
            org.jetbrains.compose.web.dom.Text(" servers will be deployed on Premium nodes, which offer higher stability. You can find more information")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.silk.components.navigation.Link("/faqs_and_info/nodes-ip-and-information") {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("here")
            }
        }
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Please note:")
        }
        org.jetbrains.compose.web.dom.Text(" if you want to move servers that you created before buying the pack, you need to open a support ticket in our Discord Support Server and wait for a developer to transfer them.")
    }
}
